import script from "./MembershipPlans.vue?vue&type=script&setup=true&lang=ts"
export * from "./MembershipPlans.vue?vue&type=script&setup=true&lang=ts"

import "./MembershipPlans.vue?vue&type=style&index=0&id=3b566c98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b566c98"]])

export default __exports__